import React from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import starYellow from '../../../assets/images/estrella_amarilla.png'
import starGray from '../../../assets/images/estrella_gris.png'
import commentImg1 from '../../../assets/images/icono_1.svg'
import commentImg2 from '../../../assets/images/icono_2.svg'
import Button from '../../../components/atoms/Button/Button';
import CommentCard from '../../molecules/comment-card/comment-card';
import './comments-section-content.scss'


const CommentsSectionContent = props => {

    const { comments, isLoader, commentPlus, handleGetComments } = props
    
    const handleRenderStars = _totalStars => {
        let starsArray = [];
        for (let i = 0; i < 5; i++) {
            if(i < _totalStars){
                starsArray.push(<img key={i} className="f-box-star" src={starYellow} />);
            }
            else{
                starsArray.push(<img key={i} className="f-box-star" src={starGray} />);
            }
        }
        return starsArray;
    }

    const sliderConf = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        className: 'f-comments-section-slider',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: "60px",
              }
            },
        ]
      }

    return (
        <section className="f-comments-section">
            <label className="f-comments-section-title">Comentarios</label>
            <Slider {...sliderConf} >
                {comments.map((comment, index) => {
                    
                    var date = comment.commentDate?.split(/[- : T]/) //YYYY MM DD HH MM SS
                    let formatedDate = date ? date[2] + "/" + date[1] + "/" + date[0] : null

                    return (
                    <React.Fragment key={index}>
                        <CommentCard
                            image={((index+1) % 2 !== 0) ? commentImg1 : commentImg2}
                            name={comment.name}
                            comment={comment.comment}
                            date={formatedDate}
                            stars={handleRenderStars(Math.floor(comment.average))}
                        />
                    </React.Fragment>
                    )
                })}
            </Slider>

            {commentPlus &&
                <div className="f-comments-section-footer">
                    <Button isEnabled={isLoader} type="button" text="Cargar más" onClickAction={handleGetComments} classname="f-button f-button--secondary" />
                </div>
            }
            
        </section>
    )
}

export default CommentsSectionContent